

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>


<br>
<br>
<br>


<!-- Privacy Policy Hero Section -->
<section class="privacy-hero">
  <div class="hero-overlay">
    <h1>Privacy Policy</h1>
  </div>
</section>

<!-- Privacy Policy Content Section -->
<section class="privacy-content container">
  <div class="policy-section">
    <h2>1. Introduction</h2>
    <p>
    Baabuji Venturess Pvt Ltd (“Company”, “we”, “our”, “us”) operates the Facheck platform (https://facheck.in & https://facheck.biz) (the “Platform”), which provides API-based digital KYC verification services and digital document signing solutions to business entities (“Clients”). This Privacy Policy describes how we collect, use, process, disclose, and safeguard information in connection with our services. 

    </p>
<p>The Company is committed to implementing data minimization and privacy-by-design principles, maintaining high standards of security and encryption, and operating strictly as a secure intermediary infrastructure layer. For the avoidance of doubt, Facheck functions solely as a technology intermediary and data processor and does not control, determine the purpose of, or own the personal data processed through its APIs. </p>

  </div>

  <div class="policy-section">
    <h2>2. Nature of Our Services</h2>
    <p>
     The Platform enables Clients to perform digital KYC verification services, including but not limited to PAN verification, Aadhaar verification (where legally permitted), GST validation, CIN and DIN verification, bank account validation, and FASTag verification. In addition, the Platform provides digital document signing capabilities using RSA 256 encryption standards and offers a dashboard interface for transaction monitoring, usage analytics, and billing reconciliation, along with prepaid wallet and postpaid billing management systems. 
    </p>
    <p>
     In the course of providing these services, the Platform operates as a secure relay mechanism whereby data submitted by Clients is encrypted and transmitted to authorized verification providers, responses are received from such providers, and the results are relayed back to the Clients. The Company does not persistently store or retain any KYC-related personal data processed through these API transactions. 
    </p>
  </div>

  <!-- Repeat sections for 3 to 15 with similar structure -->
  <div class="policy-section">
    <h2>3. Information We Collect</h2>
    <p>The Company follows a strict data minimization approach and collects only such information as is necessary for the provision, maintenance, and security of the Platform. In the course of onboarding and account management, the Company may collect business-related information including the legal entity name, details of authorized representatives, registered address, contact details such as email address and phone number, GST details where applicable, and limited KYC information of the Client where required for compliance purposes. </p>
    <p>In addition, certain technical information is collected automatically to ensure system integrity, security, and performance. This may include IP addresses, API request and response metadata excluding sensitive payloads, device and browser information, timestamps, session logs, and diagnostic or error-related data. Such information is generally non-sensitive in nature and may be anonymized or aggregated where feasible. </p>
    <p>For billing and financial transactions, the Company collects relevant billing details, including name, address, GST information, and transaction or invoice references. All payments are processed through PCI-DSS compliant, RBI-authorized payment gateways, and the Company does not store sensitive financial information such as card numbers, CVV, net banking credentials, or UPI authentication details. </p>

  </div>

  <div class="policy-section">
    <h2>4. Data Processing and Storage</h2>
    <p>All KYC-related data transmitted through the Platform is processed in real time and is securely transmitted through encrypted channels to authorized third-party verification providers. The Company does not retain or store such data in persistent storage systems. In certain cases, data may exist temporarily in volatile memory solely for the purpose of completing the transaction and is not written to disk or retained beyond the processing lifecycle. </p>
    <p>The Company may, however, maintain limited logs and metadata, such as transaction identifiers, timestamps, and API status codes, strictly for operational purposes including debugging, fraud prevention, system monitoring, and compliance audits. Such logs do not contain sensitive personal data and are retained only for as long as necessary to fulfill these purposes or to comply with legal obligations. </p>
    
  </div>

  <div class="policy-section">
    <h2>5. Data Security Measures </h2>
    <p>The Company implements industry-standard and enterprise-grade technical and organizational measures to protect data and ensure the integrity of the Platform. These measures include end-to-end encryption for data in transit, the use of TLS 1.2 or higher protocols, and RSA 256 encryption for digital document signing processes. </p>
    <p>Access to systems and data is controlled through robust access management mechanisms, including role-based access controls, adherence to the principle of least privilege, and mandatory two-factor authentication for platform access. Infrastructure-level security includes firewalls, network segmentation, intrusion detection and prevention systems, and distributed denial-of-service protection mechanisms. </p>
    <p>At the application level, the Company enforces secure API authentication, implements rate limiting, and performs input validation and sanitization to mitigate security risks. Continuous monitoring, periodic security assessments, and vulnerability testing are conducted to ensure ongoing protection, and formal incident response protocols are in place to address potential threats. </p>

    
  </div>

  <div class="policy-section">
    <h2>6. Data Sharing </h2>
    <p>The Company shares data strictly on a need-to-process basis and only to the extent required for providing the services. This includes sharing data with government-authorized KYC verification providers and relevant entities such as UIDAI, GSTN, NSDL, banking networks, or similar institutions, depending on the nature of the request initiated by the Client. </p>
    <p>The Company may also engage regulated third-party service providers, including payment gateways, cloud infrastructure providers, and compliance or audit partners, who are contractually bound to maintain confidentiality and data security standards. Disclosure of data may also occur where required by applicable law, regulatory authorities, or judicial orders, or where necessary to prevent fraud, security threats, or unlawful activities.</p>
    <p>Under no circumstances does the Company sell, rent, or otherwise monetize personal data. </p>
    
  </div>

  <div class="policy-section">
    <h2>7. Compliance </h2>
    <p>The Company operates in compliance with applicable Indian laws and regulatory frameworks, including the Information Technology Act, 2000, the Digital Personal Data Protection Act, 2023, relevant RBI guidelines for payment processing, and applicable KYC and anti-money laundering regulations. The Company’s role remains that of a data processor, acting strictly on instructions provided by Clients. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>8. User Responsibilities </h2>
    <p>Clients using the Platform are solely responsible for ensuring that they have obtained explicit, informed, and valid consent from end users before submitting their data for processing through the Platform. Clients must ensure that all data submitted is accurate, lawful, and compliant with applicable regulations, including the Digital Personal Data Protection Act, 2023, and any sector-specific regulations such as those issued by the RBI or UIDAI. </p>
    <p>The Company shall not be responsible for any misuse of personal data by Clients, including unlawful collection, processing, or sharing of such data, or failure to obtain appropriate consent. 

 </p>
    
  </div>

  <div class="policy-section">
    <h2>9. Retention Policy </h2>
    <p>The Company retains only limited operational data as necessary for the functioning of the Platform, including logs and metadata for a restricted duration based on security, audit, and legal requirements. Billing and financial records are retained in accordance with applicable tax and regulatory obligations. </p>
    <p>The Company does not retain KYC data or sensitive personal data processed through its APIs, and such data is not stored in persistent systems. </p>
    
  </div>

  <div class="policy-section">
    <h2>10. Data Breach and Incident Response </h2>
    <p>In the event of a data breach or security incident, the Company shall take immediate steps to contain and mitigate the impact of the incident. Affected Clients will be notified within a reasonable timeframe, and regulatory authorities will be informed where required under applicable laws. The Company will also undertake necessary corrective and preventive actions to avoid recurrence. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>11. Cross-Border Data Transfer </h2>
    <p>Data processed through the Platform is primarily handled within India. However, in cases where cross-border data transfer is necessary, the Company ensures that appropriate safeguards and security measures are implemented in accordance with applicable legal requirements. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>12. Rights of Data Subjects </h2>
    <p>As the Company acts as a data processor, any requests from data subjects relating to access, correction, or erasure of personal data must be directed to the respective Client who acts as the data controller. The Company will provide reasonable assistance to Clients in fulfilling such requests in accordance with applicable laws. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>13. Limitation of Responsibility </h2>
    <p>The Company shall not be responsible for the accuracy, completeness, or reliability of data obtained from third-party verification providers, nor for any delays or failures arising from external systems. The Company shall also not be liable for any decisions made by Clients based on the data provided through the Platform. </p>
    
    
  </div>

  <div class="policy-section">
    <h2>14. Changes to Policy </h2>
    <p>The Company reserves the right to modify or update this Privacy Policy at any time. Any changes will be published on the Platform and shall become effective immediately upon such publication. Continued use of the Platform constitutes acceptance of the updated Privacy Policy. </p>
    
    
  </div>



  <!-- Continue with all sections until 15. Contact -->
  <div class="policy-section">
    <h2>15. Contact</h2>
    <p>
      For any queries, grievances, or concerns relating to this Privacy Policy or data handling practices, 
      you may contact:
    </p>
    <ul>
      <li>Email: <a href="mailto:support@facheck.in">support@facheck.in</a></li>
      <li>Company: Baabuji Venturess Pvt Ltd</li>
    </ul>
  </div>
</section>


 



